export default __webpack_public_path__ + "static/media/arrowL.e6c553e8.png";